import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { getUrlParam } from '../config/windowUtils';
import styles from './MenuButtons.module.css';

const MenuButton = ({ children, menuItems, className = '' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Don't render if URL has a 'show' parameter
  const showControls = !getUrlParam('show');
  if (!showControls) {
    return null;
  }

  return (
    <div className={`${styles.container} ${className}`} ref={menuRef}>
      <div
        className={styles.trigger}
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
      >
        {children}
      </div>
      {isOpen && (
        <div className={styles.dropdown}>
          {menuItems.map((item, index) => (
            <div
              key={index}
              className={styles.item}
              onClick={(e) => {
                e.stopPropagation();
                item.onClick();
                setIsOpen(false);
              }}
            >
              {item.label}
              {item.icon && <span className={styles.itemIcon}>{item.icon}</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

MenuButton.propTypes = {
  children: PropTypes.node.isRequired,
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      icon: PropTypes.node,
    })
  ).isRequired,
  className: PropTypes.string,
};

export default MenuButton;